(function () {
    'use strict';

    // @ngInject
    Services.websocket = function websocket($window) {
        return $window.io;
    };

}());
